import React from 'react';

const ReCaptcha = () => {
    return (
        <div
            className="g-recaptcha"
            data-sitekey={process.env.GATSBY_RECAPTCHA_PUBLIC_KEY}
            data-callback="onSubmit"
            data-size="invisible"
        ></div>
    );
};

export default ReCaptcha;
